import { COUNSEL_SOURCE_MAP, COUNSEL_STATE_MAP } from "common/constants";
import { Column } from "components/Table/Simple";
import { formatDateTime } from "components/Table/Simple/presets";

export const columns: Column[] = [
    {
        field: "id",
        label: "고유번호",
    },
    {
        field: "clinic",
        label: "의원",
        render: (value, field, row) => row.clinic?.name
    },
    {
        field: "review_id",
        label: "리뷰 번호",
    },
    {
        field: "member_id",
        label: "회원 번호",
    },
    {
        field: "clinic_id",
        visible: false,
    },
    {
        field: "sourceType",
        label: "신청 경로",
        render: (value, field, row) => COUNSEL_SOURCE_MAP[row.sourceType].name
    },
    {
        field: "state",
        label: "상태",
        render: (value, field, row) => COUNSEL_STATE_MAP[row.state].name
    },
    {
        field: "sourceId",
        visible: false
    },
    {
        field: "content",
        label: "상담 내용",
    },
    {
        field: "source",
        label: "상담 경로",
        render: (value, field, row) => row.source?.name ?? row.source?.title
    },
    {
        field: "member",
        label: "닉네임",
        render: (value, field, row) => row.member?.nickname
    },
    {
        field: "created_at",
        label: "생성일",
        render: formatDateTime
    },
    {
        field: "updated_at",
        label: "수정일",
        render: formatDateTime
    }
]